import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import Collapse from "react-bootstrap/Collapse";
import Swal from "sweetalert2";
import Select from "react-select";
import PoPrintModal from './PoPrintModal';
import PoServices from "../../../services/PoServices";
import Spinner from 'react-bootstrap/Spinner';
import ReceivedOrderModal from './ReceivedOrderModal';
import BillingViewModal from './BillingViewModal';



const BillingPo = () => {
    const [sortField, setSortField] = useState(null);
    const [sortOrder, setSortOrder] = useState("asc"); // or "desc"
    const [submitting, setSubmitting] = useState(false);
    const [selectedPOs, setSelectedPOs] = useState([]);
    const [open, setOpen] = useState(false);
    const [open2, setOpen2] = useState(true);
    const [purchaseOrders, setPurchaseOrders] = useState([]);
    const [gridInsideModal, setGridInsideModal] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);
    const [sort, setSort] = useState(20);
    const [searchTerm, setSearchTerm] = useState("");
    const [gridInsideModal2, setGridInsideModal2] = useState(false);
    const [selectedItem2, setSelectedItem2] = useState(null);
    const [gridInsideModal3, setGridInsideModal3] = useState(false);
    const [selectedItem3, setSelectedItem3] = useState(null);
    const activePag = useRef(0);
    const [test, setTest] = useState(0);
    const [loading, setLoading] = useState(true);
    const [expandedRows, setExpandedRows] = useState({});




    const options = [
        { value: 5, label: '5' },
        { value: 10, label: '10' },
        { value: 20, label: '20' },
        { value: 50, label: '50' },
        { value: 100, label: '100' }
    ];

    // 1️⃣ Fetch PO list
    useEffect(() => {
        const fetchPurchaseOrders = async () => {
            try {
                setLoading(true);
                const res = await PoServices.AllPOByStatus("submittedToAdmin");
                setPurchaseOrders(res?.data || []);
            } catch (error) {
                Swal.fire("Error", "Failed to fetch purchase orders", "error");
            } finally {
                setLoading(false);
            }
        };
        fetchPurchaseOrders();
    }, [test]);

    // 2️⃣ Clear selected checkboxes on search / rows-per-page change
    useEffect(() => {
        setSelectedPOs([]);
    }, [searchTerm, sort]);




    const filteredSearch = purchaseOrders.filter(po => {
        const search = searchTerm.toLowerCase();

        const requisitionNumber = String(po?.requisitionNo?.requisitionNo || "").toLowerCase();
        const poNumber = String(po?.poNumber || "").toLowerCase();
        const supplierName = String(po?.items?.[0]?.supplier?.name || "").toLowerCase();
        const createdBy = String(po?.createdBy?.name || "").toLowerCase();
        const storeLocation = String(po?.requisitionNo?.store?.name || "").toLowerCase();

        // ⛔️ OLD — searched only first item
        // const partNo = String(po?.items?.[0]?.partNo || "").toLowerCase();
        // const descriptionSearch = String(po?.items?.[0]?.description || "").toLowerCase();

        // ✅ NEW — search ALL item partNo + ALL descriptions
        const partNoMatch = po.items?.some(
            item => String(item?.partNo || "").toLowerCase().includes(search)
        );

        const descriptionMatch = po.items?.some(
            item => String(item?.description || "").toLowerCase().includes(search)
        );

        return (
            requisitionNumber.includes(search) ||
            poNumber.includes(search) ||
            supplierName.includes(search) ||
            createdBy.includes(search) ||
            storeLocation.includes(search) ||
            partNoMatch ||
            descriptionMatch
        );
    });



    const pagination = Math.ceil(filteredSearch.length / sort);
    // ✅ CURRENT PAGE RECORDS ONLY
    const pageStart = activePag.current * sort;
    const pageEnd = (activePag.current + 1) * sort;
    const currentPageRecords = filteredSearch.slice(pageStart, pageEnd);


    const onClick = (i) => {
        activePag.current = i;
        setTest(i);
    };

    const handleViewClick = (poDetails) => {
        setSelectedItem(poDetails);       // set item to pass into modal
        setGridInsideModal(true);         // show modal
    };



    

    const handleBillingView = (e, row) => {
        e.stopPropagation(); // prevent bubbling if inside clickable row
        setSelectedItem3(row);
        setGridInsideModal3(true);
    };




    const toggleRow = (id) => {
        setSelectedPOs((prev) =>
            prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]
        );
    };

    const toggleSelectAll = () => {
        const currentPageIds = currentPageRecords.map(po => po._id);

        const allSelectedOnPage = currentPageIds.every(id =>
            selectedPOs.includes(id)
        );

        if (allSelectedOnPage) {
            // ❌ unselect ONLY current page
            setSelectedPOs(prev =>
                prev.filter(id => !currentPageIds.includes(id))
            );
        } else {
            // ✅ select ONLY current page
            setSelectedPOs(prev =>
                Array.from(new Set([...prev, ...currentPageIds]))
            );
        }
    };


    const handleBulkApproval = async () => {
        if (selectedPOs.length === 0) return;

        try {
            await PoServices.bulkApprovePO({
                poIds: selectedPOs,
                action: "approve",
                remark: "Approved"   // ✅ default remark
            });

            Swal.fire({
                icon: "success",
                title: "Approved",
                text: `${selectedPOs.length} Billing Records has been Approved!!!`,
                timer: 1500,
                showConfirmButton: false
            });

            setSelectedPOs([]);
            setTest((p) => p + 1);

        } catch (err) {
            Swal.fire("Error", "Bulk approval failed", "error");
        }
    };


    const handleReturnToBilling = async (po) => {
        try {
            setSubmitting(true);

            const { value: remark, isDismissed } = await Swal.fire({
                title: "Enter Reason",
                input: "text",
                inputLabel: "Reason",
                inputPlaceholder: "Enter reason...",
                showCancelButton: true,
                inputValidator: (v) => !v.trim() && "Reason is required"
            });

            if (isDismissed) return setSubmitting(false);

            const payload = {
                poId: po._id,
                action: "return",
                remark
            };

            await PoServices.superAdminBillingAction(payload);

            Swal.fire("Returned", "Sent back to Billing Team", "info");

            setTest((prev) => prev + 1);

        } catch (error) {
            Swal.fire("Error", "Unable to return billing", "error");
        } finally {
            setSubmitting(false);
        }
    };

    const handleApproveBillingDirect = async (po) => {
        try {
            setSubmitting(true);

            await PoServices.superAdminBillingAction({
                poId: po._id,
                action: "approve",
                amount: po?.billing?.approvedAmount || 0,
                remark: "Approved"   // ✅ default remark (same as bulk)
            });

            Swal.fire({
                icon: "success",
                title: "Approved",
                text: "1 Billing Record has been Approved!",
                timer: 1500,
                showConfirmButton: false
            });

            setTest((prev) => prev + 1);

        } catch (error) {
            Swal.fire("Error", "Unable to approve billing", "error");
        } finally {
            setSubmitting(false);
        }
    };




    const sortByApprovedAmount = () => {
        const newOrder = sortOrder === "asc" ? "desc" : "asc";
        setSortOrder(newOrder);
        setSortField("approvedAmount");

        const sorted = [...purchaseOrders].sort((a, b) => {
            const amtA = Number(a?.billing?.approvedAmount || 0);
            const amtB = Number(b?.billing?.approvedAmount || 0);

            return newOrder === "asc" ? amtA - amtB : amtB - amtA;
        });

        setPurchaseOrders(sorted);
    };

   

    const formatAmount = (value) => {
        const num = Number(value || 0);
        return num.toFixed(2);
    };
    const toggleRowExpand = (rowId, field) => {
        setExpandedRows(prev => ({
            ...prev,
            [`${rowId}-${field}`]: !prev[`${rowId}-${field}`]
        }));
    };

    const renderLimitedList = (items, rowId, field, valueKey) => {
        if (!items || items.length === 0) return "N/A";

        const isExpanded = expandedRows[`${rowId}-${field}`];
        const visibleItems = isExpanded ? items : items.slice(0, 3);
        const hiddenCount = items.length - 3;

        return (
            <>
                {visibleItems.map((item, idx) => (
                    <div key={idx}>{item?.[valueKey] || "N/A"}</div>
                ))}

                {items.length > 3 && (
                    <span
                        style={{
                            color: "#0d6efd",
                            cursor: "pointer",
                            fontSize: "12px"
                        }}
                        onClick={() => toggleRowExpand(rowId, field)}
                    >
                        {isExpanded
                            ? "Hide"
                            : `+ ${hiddenCount} more`}
                    </span>
                )}
            </>
        );
    };
    

    return (
        loading ? (
            <div className="d-flex flex-column justify-content-center align-items-center" style={{ minHeight: '200px' }}>
                <Spinner animation="border" role="status" variant="primary" />
                <p className="mt-2 fw-bold text-primary">Loading PO...</p>
            </div>
        ) : (
            <>
                {selectedItem2 && (
                    <ReceivedOrderModal
                        show={gridInsideModal2}
                        handleClose={() => setGridInsideModal2(false)}
                        test={setTest}
                        admin={selectedItem2}
                    />
                )}

                {selectedItem3 && (
                    <BillingViewModal
                        show={gridInsideModal3}
                        handleClose={() => setGridInsideModal3(false)}
                        test={setTest}
                        admin={selectedItem3}
                    />
                )}

                <PoPrintModal
                    show={gridInsideModal}
                    onHide={() => setGridInsideModal(false)}
                    item={selectedItem}
                />
                <div className="row">
                    <div className="col-xl-12">

                        {/* Filter */}
                        <div className="filter cm-content-box box-primary">
                            <div className="content-title">
                                <div className="cpa"><i className="fas fa-filter me-2"></i>Filter</div>
                                <div className="tools">
                                    <Link to="#" className={`SlideToolHeader ${open ? 'collapse' : 'expand'}`} onClick={() => setOpen(!open)}>
                                        <i className="fas fa-angle-up"></i>
                                    </Link>
                                </div>
                            </div>
                            <Collapse in={open}>
                                <div className="cm-content-body form excerpt">
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col-xl-3 col-xxl-6 mb-3">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Search by Requisition No., Po Number, Supplier Name, Store"
                                                    value={searchTerm}
                                                    onChange={(e) => setSearchTerm(e.target.value)}
                                                />
                                            </div>
                                            <div className="col-xl-3 col-xxl-6 mb-3">
                                                <Select
                                                    placeholder="Rows per page"
                                                    value={options.find(option => option.value === sort)}
                                                    onChange={(selectedOption) => setSort(Number(selectedOption.value))}
                                                    isSearchable={false}
                                                    options={options}
                                                    className="custom-react-select"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Collapse>
                        </div>

                        {/* Table */}
                        <div className="filter cm-content-box box-primary">
                            {/* Table Header: Title + Download */}
                            <div className="content-title d-flex justify-content-between align-items-center">
                                <div className="cpa">
                                    <i className="fa fa-list me-2"></i>Approval Pending For Billing
                                    <span className="badge bg-orange ms-2">{filteredSearch.length}</span>
                                </div>

                                <div className="d-flex align-items-center gap-2">
                                    <button
                                        style={{ padding: "8px 10px", fontSize: "13px" }}   // reduce height
                                        className="btn btn-success me-3"
                                        disabled={selectedPOs.length === 0}
                                        onClick={handleBulkApproval}
                                    >
                                        Approve Selected ({selectedPOs.length})
                                    </button>




                                    {/* Collapse toggle */}
                                    <Link
                                        to="#"
                                        className={`SlideToolHeader ${open2 ? "collapse" : "expand"}`}
                                        onClick={() => setOpen2(!open2)}
                                        style={{ marginLeft: "10px" }}
                                    >
                                        <i className="fas fa-angle-up"></i>
                                    </Link>
                                </div>
                            </div>


                            <Collapse in={open2}>
                                <div className="cm-content-body form excerpt">
                                    <div className="card-body">
                                        <div className="table-responsive">
                                            <div id="content_wrapper" className="dataTables_wrapper no-footer">
                                                <div style={{
                                                    overflowX: 'auto',
                                                    overflowY: 'auto',
                                                    maxHeight: '400px',
                                                    whiteSpace: 'nowrap'
                                                }}>
                                                    <table className="table table-bordered table-responsive-lg table-striped table-condensed flip-content" id="active-users-data">
                                                        <thead
                                                            style={{
                                                                position: "sticky",
                                                                top: 0,
                                                                backgroundColor: "#fff",
                                                                zIndex: 2,
                                                            }}
                                                        >
                                                            <tr>
                                                                <th>
                                                                    <input
                                                                        type="checkbox"
                                                                        checked={
                                                                            currentPageRecords.length > 0 &&
                                                                            currentPageRecords.every(po => selectedPOs.includes(po._id))
                                                                        }

                                                                        onChange={toggleSelectAll}
                                                                    />
                                                                </th>
                                                                <th>#</th>
                                                                <th>Summary</th>
                                                                <th>Requisition</th>
                                                                <th onClick={sortByApprovedAmount} style={{ cursor: "pointer" }}>
                                                                    Approved Amount{" "}
                                                                    {sortField !== "approvedAmount" ? (
                                                                        <span style={{ color: "#999" }}>⇅</span>   // default icon on load
                                                                    ) : sortOrder === "asc" ? (
                                                                        " 🔼"
                                                                    ) : (
                                                                        " 🔽"
                                                                    )}
                                                                </th>


                                                                <th>Po</th>
                                                                <th>Part No</th>
                                                                <th>Description</th>
                                                                <th>Po Qty</th>
                                                                <th>Po Rate</th>
                                                                <th>Store</th>
                                                                <th>Suppplier</th>
                                                                <th>Delivery Address</th>
                                                                <th
                                                                    onClick={sortByApprovedAmount}
                                                                    style={{
                                                                        cursor: "pointer",
                                                                        width: "110px",
                                                                        minWidth: "110px",
                                                                        textAlign: "center",
                                                                        whiteSpace: "nowrap"
                                                                    }}
                                                                >
                                                                    Approved Amount{" "}
                                                                    {sortField !== "approvedAmount" ? (
                                                                        <span style={{ color: "#999" }}>⇅</span>
                                                                    ) : sortOrder === "asc" ? (
                                                                        " 🔼"
                                                                    ) : (
                                                                        " 🔽"
                                                                    )}
                                                                </th>


                                                                <th>Items</th>
                                                                <th>Action</th>
                                                            </tr>
                                                        </thead>


                                                        <tbody>
                                                            {filteredSearch.length > 0 ? (
                                                                filteredSearch
                                                                    .slice(activePag.current * sort, (activePag.current + 1) * sort)
                                                                    .map((row, index) => (
                                                                        <tr key={index}>
                                                                            <td>
                                                                                <input
                                                                                    type="checkbox"
                                                                                    checked={selectedPOs.includes(row._id)}
                                                                                    onChange={() => toggleRow(row._id)}
                                                                                />
                                                                            </td>

                                                                            <td>{activePag.current * sort + index + 1}</td>
                                                                            <td><button
                                                                                className="btn btn-dark d-flex flex-column align-items-center justify-content-center py-1 px-2"
                                                                                style={{ width: "30px", borderRadius: "8px", height: "35px" }}
                                                                                onClick={(e) => { handleBillingView(e, row) }}

                                                                            >
                                                                                <i className="fa-solid fa-file-lines text-white fs-5"></i>


                                                                            </button></td>
                                                                            <td>{row?.requisitionNo?.requisitionNo || row?.requisitionNo?._id || 'N/A'}</td>
                                                                            <td
                                                                                className="text-center"
                                                                                style={{
                                                                                    width: "110px",
                                                                                    minWidth: "110px",
                                                                                    whiteSpace: "nowrap"
                                                                                }}
                                                                            >
                                                                                {formatAmount(row?.billing?.approvedAmount)}
                                                                            </td>


                                                                            <td onClick={() => handleViewClick(row)}>{row?.poNumber || 'N/A'}</td>
                                                                            <td>
                                                                                {renderLimitedList(row?.items, row._id, "partNo", "partNo")}
                                                                            </td>

                                                                            <td className="scrollable-description">
                                                                                {renderLimitedList(row?.items, row._id, "description", "description")}
                                                                            </td>




                                                                            <td>
                                                                                {renderLimitedList(row?.items, row._id, "poQty", "approveQty")}
                                                                            </td>
                                                                            <td>
                                                                                {renderLimitedList(row?.items, row._id, "poRate", "rate")}
                                                                            </td>

                                                                            <td className="scrollable-description">{row?.requisitionNo?.store?.name}</td>
                                                                            <td className="scrollable-description">
                                                                                {row?.items?.[0]?.supplier?.name || "N/A"}
                                                                            </td>

                                                                            <td className="scrollable-description">
                                                                                {row?.deliveryAddress?.street}, {row?.deliveryAddress?.city},<br />
                                                                                {row?.deliveryAddress?.state} - {row?.deliveryAddress?.pincode},<br />
                                                                                {row?.deliveryAddress?.country}
                                                                            </td>
                                                                            <td>{new Date(row?.createdAt).toLocaleDateString('en-IN')}</td>
                                                                            <td>{row?.items?.length || 0}</td>


                                                                            <td>
                                                                                <div className="d-flex gap-2 justify-content-center">
                                                                                    <button
                                                                                        disabled={submitting}
                                                                                        className="btn btn-success d-flex flex-column align-items-center justify-content-center py-1 px-2"
                                                                                        style={{ width: "60px", borderRadius: "8px", height: "55px" }}
                                                                                        onClick={() => handleApproveBillingDirect(row)}
                                                                                    >
                                                                                        <i className="fa-solid fa-check text-white fs-5 mb-1"></i>
                                                                                        <span className="text-white" style={{ fontSize: '10px' }}>Approve</span>
                                                                                    </button>

                                                                                    <button
                                                                                        onClick={() => handleReturnToBilling(row)}
                                                                                        className="btn btn-warning d-flex flex-column align-items-center justify-content-center py-1 px-2"
                                                                                        style={{ width: "60px", borderRadius: "8px", height: "55px" }}
                                                                                    >
                                                                                        <i className="fa-solid fa-rotate-left text-white fs-5 mb-1"></i>
                                                                                        <span className="text-white" style={{ fontSize: '10px' }}>Billing Team</span>
                                                                                    </button>

                                                                                </div>
                                                                            </td>

                                                                        </tr>
                                                                    ))
                                                            ) : (
                                                                <tr><td colSpan="13" className="text-center">No Purchase Orders Found</td></tr>
                                                            )}
                                                        </tbody>
                                                    </table>
                                                </div>

                                                {/* Pagination */}
                                                <div className="d-flex justify-content-between align-items-center mt-3">
                                                    <div className="dataTables_info">
                                                        Showing {filteredSearch.length > 0 ? (activePag.current * sort + 1) : 0} to{" "}
                                                        {Math.min(filteredSearch.length, (activePag.current + 1) * sort)} of {filteredSearch.length} entries
                                                    </div>
                                                    <div className="dataTables_paginate paging_simple_numbers">
                                                        <Link className="paginate_button previous" to="#" onClick={() => activePag.current > 0 && onClick(activePag.current - 1)}>
                                                            <i className="fa fa-angle-double-left"></i>
                                                        </Link>
                                                        <span>
                                                            {Array.from({ length: pagination }, (_, i) => (
                                                                <Link
                                                                    key={i}
                                                                    to="#"
                                                                    className={`paginate_button ${activePag.current === i ? "current" : ""}`}
                                                                    onClick={() => onClick(i)}
                                                                >
                                                                    {i + 1}
                                                                </Link>
                                                            ))}
                                                        </span>
                                                        <Link className="paginate_button next" to="#" onClick={() => activePag.current < pagination - 1 && onClick(activePag.current + 1)}>
                                                            <i className="fa fa-angle-double-right"></i>
                                                        </Link>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Collapse>
                        </div>
                    </div>
                </div>
            </>
        )
    );
};

export default BillingPo;
